import { render } from "./TestLogin.vue?vue&type=template&id=957f8036"
import script from "./TestLogin.vue?vue&type=script&lang=js"
export * from "./TestLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__